var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)",
    fillOpacity: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_724_1914",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_724_1914",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAB5ElEQVRoge2ZsU4VQRSG/4PGYKIBSSgpqNCKwpDQUNMaH4AEwgvoO9AZKVUqEysj0thYQOxsLLBEqSCESjBsNLEAPot7E8dl2Z2BnTv3JvNVm7nn7Pn/PTm7s3ulTCaT6RuACWAdKOgdBbABTF1Fs7niJX2VNNbWBQnkWNK0mR2EJA05x6tKJ17d2s9Dk9wOFJLutqnoChRmNhKS4BqgfT3hmJk1R/1jqDmkv8kGUnMztYAmyrNZnpGB70A2kJrYBr5LWoxZIKaB35Iem9lrSS8j1ukQYZe54Jx7GNj2SWrSdV0Dz4BPHnEvKs7/APiV0sAWcAMYA3Zr4raB25fUWEplYB8Yd2LvAz8r4o6ByUuLdHLf9NrAH2CmIn4eOHXizoFHdeK7eXeAnV4aWK7JeerErTSJd/Iedi9MdANrHmJe0RnsoH0V8CS2gS/AsIeQWzjzEWDAgA+xDBzRMIxtANwD9to2cAbMR1X+f905nJtBja7K3/vtpf7EzEbdhbLouveBzYjCfAnW4HZgStJnpf2wNWtmu+6idwfM7JukaUnvJBXxdF6gkPReFeJ9CPoGk4KQGRhIsoHUeO9fap+CveOkvDBoHfhYXvC+C/VBB36o8wfIobs4CB0oJL1VhfhMJpNJz18iIG6So7C/wwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/uploadImg.182b656b786627e15f8b5831b639a06c.svg";
export { ForwardRef as ReactComponent };